import classNames from 'classnames';

import SvgIcon from '../SvgIcon';

import ICircleButton from './types';
import useStyles from './styles';

function CircleButton({ className, disabled, iconName, onClick }: ICircleButton) {
  const classes = useStyles();

  return (
    <button className={classNames(classes.root, className)} onClick={onClick} disabled={disabled}>
      <SvgIcon className={classes.icon} name={iconName} />
    </button>
  );
}

export default CircleButton;
